/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import {
  Loading,
  IButtonProps,
} from '@sede-enterprise/shell-ds-react-framework';
import { ShellButton } from './style';

const Button: FC<IButtonProps> = ({
  variant,
  children,
  loading = false,
  ...rest
}) => {
  return (
    <ShellButton variant={variant} {...rest}>
      {loading && (
        <Loading
          data-testid='loading-indicator'
          type={variant === 'filled' ? 'primary' : 'default'}
        />
      )}{' '}
      {children}
    </ShellButton>
  );
};

export default Button;
